// src/pages/Dashboard/Admin/Inventaire/components/InventaireDataTable.jsx

import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

import {
  getInventairePhotoSrc,
  getStockStatus,
  getStockStatusClass,
  getStockStatusLabel,
  toStockNumber,
} from "../utils/inventaireDashboardUtils";

export default function InventaireDataTable({
  items = [],
  onEdit,
  onDelete,
  deletingId,
}) {
  return (
    <div className="hidden md:block">
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900/60">
        <table className="min-w-[980px] w-full">
          <thead className="sticky top-0 z-20">
            <tr className="bg-slate-50 text-xs uppercase tracking-wide text-slate-600 dark:bg-slate-900 dark:text-slate-300">
              <th className="w-24 px-4 py-3 text-left font-bold">Photo</th>
              <th className="px-4 py-3 text-left font-bold">Objet</th>
              <th className="px-4 py-3 text-left font-bold">Catégorie</th>
              <th className="px-4 py-3 text-left font-bold">Stock</th>
              <th className="px-4 py-3 text-left font-bold">État</th>
              <th className="px-4 py-3 text-left font-bold">Note</th>
              <th className="sticky right-0 z-30 w-32 bg-slate-50 px-4 py-3 text-right font-bold dark:bg-slate-900">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 text-sm dark:divide-slate-800">
            {items.map((item) => {
              const stockStatus = getStockStatus(item);

              return (
                <tr
                  key={item.id}
                  className="transition hover:bg-slate-50/80 dark:hover:bg-slate-800/40"
                >
                  <td className="px-4 py-3">
                    <img
                      src={getInventairePhotoSrc(item.photo_url)}
                      alt={item.nom || "Objet inventaire"}
                      className="h-14 w-14 rounded-2xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
                      onError={(event) => {
                        event.currentTarget.src = "/img/no-image.jpg";
                      }}
                    />
                  </td>

                  <td className="px-4 py-3">
                    <div className="font-bold text-slate-900 dark:text-white">
                      {item.nom || "—"}
                    </div>
                  </td>

                  <td className="px-4 py-3">
                    <span className="inline-flex rounded-full bg-slate-100 px-2.5 py-1 text-xs font-bold text-slate-700 dark:bg-slate-800 dark:text-slate-300">
                      {item.categorie || "—"}
                    </span>
                  </td>

                  <td className="px-4 py-3">
                    <span className="inline-flex min-w-14 items-center justify-center rounded-2xl border border-slate-200 bg-white px-3 py-1 text-sm font-bold text-slate-900 dark:border-slate-700 dark:bg-slate-900 dark:text-white">
                      {toStockNumber(item.stock)}
                    </span>
                  </td>

                  <td className="px-4 py-3">
                    <span
                      className={`inline-flex rounded-full px-2.5 py-1 text-xs font-bold ring-1 ${getStockStatusClass(
                        stockStatus
                      )}`}
                    >
                      {getStockStatusLabel(stockStatus)}
                    </span>
                  </td>

                  <td className="px-4 py-3">
                    <p className="max-w-[360px] text-sm leading-6 text-slate-600 dark:text-slate-300">
                      {item.note || "—"}
                    </p>
                  </td>

                  <td className="sticky right-0 z-10 bg-white px-4 py-3 dark:bg-slate-900">
                    <div className="flex items-center justify-end gap-2">
                      <button
                        type="button"
                        onClick={() => onEdit(item)}
                        className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 hover:text-indigo-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                        title="Modifier"
                      >
                        <FaEdit />
                      </button>

                      <button
                        type="button"
                        onClick={() => onDelete(item)}
                        disabled={deletingId === item.id}
                        className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-rose-200 bg-rose-50 text-rose-700 transition hover:bg-rose-100 disabled:opacity-50 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300"
                        title="Supprimer"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}